/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Profile_Complete_BodyInputs */

const en_us2_profile_complete_body = /** @type {(inputs: Profile_Complete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your plan uses all ${i?.total} answers.`)
};

const pt_br2_profile_complete_body = /** @type {(inputs: Profile_Complete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu plano usa todas as ${i?.total} respostas.`)
};

const es_419_profile_complete_body = /** @type {(inputs: Profile_Complete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu plan usa las ${i?.total} respuestas.`)
};

const pt_pt2_profile_complete_body = /** @type {(inputs: Profile_Complete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O teu plano usa todas as ${i?.total} respostas.`)
};

const fr_fr2_profile_complete_body = /** @type {(inputs: Profile_Complete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ton programme utilise les ${i?.total} réponses.`)
};

const de_de2_profile_complete_body = /** @type {(inputs: Profile_Complete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Plan nutzt alle ${i?.total} Antworten.`)
};

const it_it2_profile_complete_body = /** @type {(inputs: Profile_Complete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La tua scheda usa tutte le ${i?.total} risposte.`)
};

/**
* | output |
* | --- |
* | "Your plan uses all {total} answers." |
*
* @param {Profile_Complete_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_complete_body = /** @type {((inputs: Profile_Complete_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Complete_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_complete_body(inputs)
	if (locale === "es-419") return es_419_profile_complete_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_complete_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_complete_body(inputs)
	if (locale === "de-DE") return de_de2_profile_complete_body(inputs)
	if (locale === "it-IT") return it_it2_profile_complete_body(inputs)
	return en_us2_profile_complete_body(inputs)
});
export { profile_complete_body as "profile.complete_body" }